import { render, staticRenderFns } from "./subprogram-nba-rounds-form.vue?vue&type=template&id=feddc11c&"
import script from "./subprogram-nba-rounds-form.vue?vue&type=script&lang=js&"
export * from "./subprogram-nba-rounds-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports